import { Box, Typography } from "@mui/material";

import { grey } from "@mui/material/colors";

export default function DashedBreakline({ text }: { text: string }) {
  return (
    <Box sx={{ my: 2 }}>
      <Typography sx={{
        fontSize: 13,
        color: grey[700],
        textAlign: 'center',
        position: 'relative',
        '&:before': { content: '" "', width: '100px', height: '1px', position: 'absolute', top: '10px', left: 0, bgcolor: '#f1f1f1' },
        '&:after': { content: '" "', width: '100px', height: '1px', position: 'absolute', top: '10px', right: 0, bgcolor: '#f1f1f1' }
      }}>{text}</Typography>
    </Box>
  )
}